import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("kys_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Customer-account client: separate token from the admin session.
export const capi = axios.create({ baseURL: API });
capi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("kys_customer_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Resolve an image ref (string or {url}) to a full URL.
export const fileUrl = (ref) => {
  if (!ref) return "";
  let u = typeof ref === "object" ? ref.url : ref;
  if (!u) return "";
  return u.startsWith("http") ? u : `${BACKEND}${u}`;
};

export const money = (v) => {
  if (v === null || v === undefined) return "—";
  const n = Number(v);
  if (!n) return "$0.00";
  return `$${n.toFixed(2)}`;
};

export function apiError(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? x.msg : JSON.stringify(x))).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}
